import PropTypes from "prop-types";

const Loader = ({ style }) => {
  const defaultStyle = {
    textAlign: 'center',
    color: '#000',
    fontWeight: 'bold',
    display: 'inline-block',
    position: 'relative',
    top: '50%',
    left: '50%',
    fontSize: '30px',
  };

  return (
    <i className="fa-solid fa-spinner fa-spin" style={{ ...defaultStyle, ...(style || {}) }}></i>
  );
};

Loader.propTypes = {
  style: PropTypes.object,
};

export default Loader;